import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Profile from '../components/profile';
import * as authActions from '../actions/authActions';
import * as landingPageAction from '../actions/landingPageAction';

function mapStateToProps(state) {
  return {
    userInfo: state.Chargecard.userInfo,
    auth: state.auth,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...authActions,
      ...landingPageAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
